import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="nested-form"
export default class extends Controller {
  static targets = ["links", "template"];

  connect() {
    this.wrapperClass = this.data.get("wrapperClass") || "nested-fields";
  }

  add_association(event) {
    event.preventDefault();

    var content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime()
    );
    // Insert the new fields before the links target
    this.linksTarget.insertAdjacentHTML("beforebegin", content);
  }

  remove_association(event) {
    event.preventDefault();
    const target = event.currentTarget;

    // Check if the remove button is disabled (e.g., due to dependencies)
    if (target.disabled || target.classList.contains("cursor-not-allowed")) {
      return;
    }

    if (
      target.dataset &&
      target.dataset.confirmMessage &&
      !confirm(target.dataset.confirmMessage)
    )
      return;

    let wrapper = target.closest("." + this.wrapperClass);

    // Check if wrapper has a dependency indicator
    const dependencyNote = wrapper.querySelector(".dependency-note");
    if (dependencyNote) {
      const message = dependencyNote.textContent || "This item cannot be removed because it is in use.";
      alert(message);
      return;
    }

    if (wrapper.dataset.newRecord == "true") {
      wrapper.remove();
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1;
      wrapper.style.display = "none";
    }
  }
}
